import http from '@core/fetch'

export default {
  // 话题详情
  getTopicDetail: body =>
    http('/hps/home/note/noteTopic/topicDetail', {
      body
    }),

  //动态列表
  getNoteList: body =>
    http('/p/wedding/index.php/admin/APINote/noteList', { body }),

  //发布动态
  publishNote: body =>
    http.post('/p/wedding/index.php/Home/APINote/create', {
      body,
      ignore: [null, undefined]
    })
}
